<template>
  <form method="post" @submit.prevent="send" novalidate>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title is-centered">
          {{ $t('attributes.add') + $t('attributes.collaborate_group') }}
        </p>
      </header>
      <section class="modal-card-body">
        <form-wrapper :validator="$v.form">
          <b-field grouped>
            <b-field expanded>
              <template #label>
                {{ $t('attributes.product') }}
                <!-- eslint-disable-next-line-->
                <span v-if="selectedProductName" v-html="': ' + selectedProductName"></span>
              </template>
              <form-group name="product_code" expanded>
                <b-autocomplete
                  ref="product_code_input"
                  v-model="form.product_code"
                  name="product_code"
                  field="code"
                  :data="products"
                  :loading="isLoadingProducts"
                  :placeholder="$t('message.please_input_product_code')"
                  :open-on-focus="false"
                  @typing="loadProducts"
                  @select="onSelectProduct"
                >
                  <template #default="props">
                    <p>
                      {{ props.option.code }} -
                      <!-- eslint-disable-next-line-->
                      <span v-html="props.option.name"></span>
                    </p>
                  </template>
                  <template #empty>
                    {{
                      form.product_code
                        ? isLoadingProducts
                          ? $t('attributes.searching')
                          : $t('attributes.not_found')
                        : $t('message.please_input_product_code')
                    }}
                  </template>
                </b-autocomplete>
              </form-group>
            </b-field>

            <form-group
              name="serial"
              attribute="attributes.group_serial"
              :label="$t('attributes.group_serial')"
            >
              <b-select
                v-model="form.serial"
                name="serial"
                :placeholder="
                  $t('message.please_select') + $t('attributes.group_serial')
                "
                expanded
              >
                <option
                  v-for="option in group_serials"
                  :key="option"
                  :value="option"
                >
                  {{ option }}
                </option>
              </b-select>
            </form-group>
          </b-field>

          <form-group
            name="collaborate_id"
            attribute="attributes.collaborate"
            :label="$t('attributes.collaborate')"
          >
            <b-autocomplete
              v-model="collaborate_name"
              name="collaborate_name"
              field="name"
              :data="filteredCollaborates"
              :loading="isLoadingCollaborates"
              :placeholder="
                $t('message.please_input') +
                  $t('attributes.collaborate') +
                  $t('attributes.name')
              "
              :open-on-focus="true"
              @typing="filteringCollaborates"
              @select="onSelectCollaborate"
            >
              <template #empty>
                {{ collaborate_name ? '找不到' : '請輸入企業名稱' }}
              </template>
            </b-autocomplete>
          </form-group>

          <form-group
            name="activity_id"
            attribute="attributes.collaborate_activity"
            :label="$t('attributes.collaborate_activity')"
          >
            <b-autocomplete
              v-model="activity_name"
              name="activity_name"
              field="name"
              :loading="isLoadingActivities"
              :data="filteredActivities"
              :placeholder="
                $t('attributes.collaborate_activity') + $t('attributes.name')
              "
              :open-on-focus="true"
              @typing="filteringActivities"
              @select="onSelectActivity"
            >
              <template #empty>
                {{
                  !this.form.collaborate_id ? '請先選擇企業' : '尚未建立活動'
                }}
              </template>
            </b-autocomplete>
          </form-group>

          <b-field grouped>
            <b-field expanded>
              <template #label>
                {{ $t('attributes.collaborate_common_questions_group') }}
                <!-- eslint-disable-next-line-->
                <span v-if="selectedCommonQuestionsGroupName" v-html="': ' + selectedCommonQuestionsGroupName"></span>
              </template>
              <form-group name="common_questions_group_code" expanded>
                <b-autocomplete
                  ref="common_questions_group_code_input"
                  v-model="common_questions_group_code"
                  name="common_questions_group_code"
                  field="code"
                  :data="common_questions_groups"
                  :loading="isLoadingCommonQuestionsGroups"
                  :placeholder="
                    $t('message.please_input_common_questions_group_code')
                  "
                  :open-on-focus="false"
                  dropdown-position="top"
                  @typing="loadCommonQuestionsGroups"
                  @select="onSelectCommonQuestionsGroup"
                >
                  <template #default="props">
                    <p>
                      {{ props.option.code }} -
                      <!-- eslint-disable-next-line-->
                      <span v-html="props.option.name"></span>
                    </p>
                  </template>
                  <template #empty>
                    {{
                      common_questions_group_code
                        ? isLoadingCommonQuestionsGroups
                          ? $t('attributes.searching')
                          : $t('attributes.not_found')
                        : $t('message.please_input_common_questions_group_code')
                    }}
                  </template>
                </b-autocomplete>
              </form-group>
            </b-field>
          </b-field>

          <b-field grouped>
            <b-field expanded>
              <template #label>
                {{ $t('attributes.collaborate_spot_questions_group') }}
                <!-- eslint-disable-next-line-->
                <span v-if="selectedSpotQuestionsGroupName" v-html="': ' + selectedSpotQuestionsGroupName"></span>
              </template>
              <form-group name="spot_questions_group_code" expanded>
                <b-autocomplete
                  ref="spot_questions_group_code_input"
                  v-model="spot_questions_group_code"
                  name="spot_questions_group_code"
                  field="code"
                  :data="spot_questions_groups"
                  :loading="isLoadingSpotQuestionsGroups"
                  :placeholder="
                    $t('message.please_input_spot_questions_group_code')
                  "
                  :open-on-focus="false"
                  dropdown-position="top"
                  @typing="loadSpotQuestionsGroups"
                  @select="onSelectSpotQuestionsGroup"
                >
                  <template #default="props">
                    <p>
                      {{ props.option.code }} -
                      <!-- eslint-disable-next-line-->
                      <span v-html="props.option.name"></span>
                    </p>
                  </template>
                  <template #empty>
                    {{
                      spot_questions_group_code
                        ? isLoadingSpotQuestionsGroups
                          ? $t('attributes.searching')
                          : $t('attributes.not_found')
                        : $t('message.please_input_spot_questions_group_code')
                    }}
                  </template>
                </b-autocomplete>
              </form-group>
            </b-field>
          </b-field>

          <form-group name="quantity" :label="$t('attributes.quantity')">
            <b-input
              v-model.number="form.quantity"
              type="number"
              name="quantity"
              min="1"
              :placeholder="
                $t('message.please_input') + $t('attributes.quantity')
              "
            >
            </b-input>
          </form-group>

          <form-group
            name="departure_date"
            :label="$t('attributes.departure_date')"
            expanded
          >
            <b-datepicker
              v-model="departure_date"
              name="departure_date"
              :placeholder="
                $t('message.please_input') + $t('attributes.departure_date')
              "
              :min-date="min_date"
              :mobile-native="false"
              :date-formatter="formatDate"
              position="is-top-right"
              @input="onSelectDepartureDate"
            >
            </b-datepicker>
          </form-group>

          <form-group
            name="registration_range"
            attribute="attributes.registration_range"
            :label="$t('attributes.registration_range')"
            expanded
          >
            <b-datepicker
              v-model="registration_range"
              name="registration_range"
              :date-formatter="formatDates"
              :min-date="min_date"
              :max-date="registration_max_date"
              :mobile-native="false"
              :placeholder="
                $t('message.please_input') + $t('attributes.registration_range')
              "
              position="is-top-right"
              icon="calendar-today"
              trap-focus
              range
              @input="onSelectRegistrationRange"
            >
            </b-datepicker>
          </form-group>

          <form-group
            name="signup_deadline"
            :label="$t('attributes.signup_deadline')"
            expanded
          >
            <b-datepicker
              v-model="signup_deadline"
              name="signup_deadline"
              :placeholder="
                $t('message.please_input') + $t('attributes.signup_deadline')
              "
              :min-date="deadline_min_date"
              :max-date="deadline_max_date"
              :mobile-native="false"
              :date-formatter="formatDate"
              position="is-top-left"
              @input="onSelectSignupDeadline"
            >
            </b-datepicker>
          </form-group>
        </form-wrapper>
      </section>
      <footer class="modal-card-foot">
        <b-button :loading="isSending" @click="$parent.close()">
          {{ $t('attributes.cancel') }}
        </b-button>
        <b-button
          :loading="isSending || isLoading"
          type="is-primary"
          native-type="submit"
        >
          {{ $t('attributes.add') }}
        </b-button>
      </footer>
    </div>
  </form>
</template>

<script>
import debounce from 'lodash/debounce'
import {
  required,
  numeric,
  minValue,
  maxValue,
  between
} from 'vuelidate/lib/validators'
import {
  PRODUCTS_API,
  FIRM_COLLABORATES_API,
  FIRM_COLLABORATES_ACTIVITIES_API,
  TRAVEL_GROUPS_API
} from '@/utils/apis'
import notifyService from '@/services/notifyService'

export default {
  name: 'TravelGroupCreateForm',

  props: {
    isSending: {
      type: Boolean,
      default: true
    }
  },
  data() {
    const minDate = this.$dayjs()
      .startOf('day')
      .toDate()

    return {
      isLoadingProducts: false,
      products: [],
      selectedProductName: null,

      group_serials: ['U', 'V', 'W', 'X', 'Y', 'Z'],

      isLoadingCollaborates: false,
      collaborate_name: '',
      collaborates: [],
      filteredCollaborates: [],

      isLoadingActivities: false,
      activity_name: '',
      activities: [],
      filteredActivities: [],

      isLoadingCommonQuestionsGroups: false,
      common_questions_groups: [],
      selectedCommonQuestionsGroupName: null,
      common_questions_group_code: null,

      isLoadingSpotQuestionsGroups: false,
      spot_questions_groups: [],
      selectedSpotQuestionsGroupName: null,
      spot_questions_group_code: null,

      min_date: minDate,
      departure_date: null,
      registration_range: [],
      signup_deadline: null,

      form: {
        product_code: null,
        serial: 'U',
        collaborate_id: null,
        activity_id: null,
        quantity: 0,
        departure_date: null,
        registration_start_date: null,
        registration_end_date: null,
        signup_deadline: null
      }
    }
  },
  validations() {
    return {
      form: {
        product_code: { required },
        serial: { required },
        collaborate_id: { required },
        activity_id: { required },
        quantity: { required, numeric, minValue: minValue(1) },
        departure_date: { required },
        registration_start_date: { required },
        registration_end_date: {
          required,
          maxValue: maxValue(this.departure_date)
        },
        signup_deadline: {
          required,
          between: between(
            this.form.registration_start_date,
            this.form.registration_end_date
          )
        }
      }
    }
  },
  computed: {
    isLoading() {
      return (
        this.isLoadingCollaborates ||
        this.isLoadingActivities ||
        this.isLoadingProducts ||
        this.isLoadingCommonQuestionsGroups ||
        this.isLoadingSpotQuestionsGroups
      )
    },
    registration_max_date() {
      if (!this.departure_date) {
        return null
      }

      return this.$dayjs(this.departure_date)
        .subtract(1, 'day')
        .toDate()
    },
    deadline_min_date() {
      if (this.form.registration_start_date) {
        return this.form.registration_start_date
      }

      return this.min_date
    },
    deadline_max_date() {
      if (this.form.registration_end_date) {
        return this.form.registration_end_date
      }

      if (this.form.departure_date) {
        return this.$dayjs(this.form.departure_date)
          .subtract(1, 'day')
          .toDate()
      }

      return null
    }
  },
  mounted() {
    this.$refs.product_code_input.focus()
    this.loadCollaborates()
  },
  methods: {
    async loadCollaborates() {
      const api = `${FIRM_COLLABORATES_API}/list`

      this.isLoadingCollaborates = true
      try {
        const res = await this.axios.get(api)
        this.collaborates = res.data.data
        this.filteringCollaborates()
      } catch (e) {
        this.collaborates = []
        this.filteredCollaborates = []
        this.form.collaborate_id = null

        notifyService.fetch_error('collaborate', e)
      } finally {
        this.isLoadingCollaborates = false
      }
    },
    async loadActivities() {
      const api = `${FIRM_COLLABORATES_ACTIVITIES_API}/list`
      const params = {
        collaborate_id: this.form.collaborate_id
      }

      this.isLoadingActivities = true
      try {
        const res = await this.axios.get(api, { params })
        this.activities = res.data.data
        this.activity_name = ''
        this.filteringActivities()
      } catch (e) {
        this.activities = []
        this.filteredActivities = []
        this.form.activity_id = null

        notifyService.fetch_error('collaborate_activity', e)
      } finally {
        this.isLoadingActivities = false
      }
    },
    async loadAsyncProducts() {
      const api = `${PRODUCTS_API}/list`

      const params = {
        code: this.form.product_code
      }

      this.isLoadingProducts = true
      try {
        const res = await this.axios.get(api, { params })
        this.products = res.data.data
      } catch (e) {
        this.products = []

        notifyService.fetch_error('product', e)
      } finally {
        this.isLoadingProducts = false
      }
    },
    loadProducts: debounce(function() {
      this.loadAsyncProducts()
    }, 1500),
    onSelectProduct(option) {
      this.selectedProductName = option && option.name
    },
    onSelectCollaborate(option) {
      const id = option && option.id

      if (this.form.collaborate_id === id) {
        return
      }

      this.form.collaborate_id = id
      this.form.activity_id = null
      this.activity_name = ''
      this.activities = []
      this.filteredActivities = []
      this.loadActivities()
    },
    onSelectActivity(option) {
      const id = option && option.id

      if (this.form.activity_id === id) {
        return
      }

      this.form.activity_id = id
    },
    async loadAsyncCommonQuestionsGroups() {
      const api = `${TRAVEL_GROUPS_API}/search/collaborate`
      const params = {
        code: this.common_questions_group_code
      }

      this.isLoadingCommonQuestionsGroups = true
      try {
        const res = await this.axios.get(api, { params })
        this.common_questions_groups = res.data.data
      } catch (e) {
        this.common_questions_groups = []

        notifyService.fetch_error('collaborate_group', e)
      } finally {
        this.isLoadingCommonQuestionsGroups = false
      }
    },
    loadCommonQuestionsGroups: debounce(function() {
      if (!this.common_questions_group_code) {
        this.common_questions_groups = []
        return
      }

      this.loadAsyncCommonQuestionsGroups()
    }, 1000),
    onSelectCommonQuestionsGroup(option) {
      this.selectedCommonQuestionsGroupName = option && option.name
    },
    async loadAsyncSpotQuestionsGroups() {
      const api = `${TRAVEL_GROUPS_API}/search/collaborate`
      const params = {
        code: this.spot_questions_group_code
      }

      this.isLoadingSpotQuestionsGroups = true
      try {
        const res = await this.axios.get(api, { params })
        this.spot_questions_groups = res.data.data
      } catch (e) {
        this.spot_questions_groups = []

        notifyService.fetch_error('collaborate_group', e)
      } finally {
        this.isLoadingSpotQuestionsGroups = false
      }
    },
    loadSpotQuestionsGroups: debounce(function() {
      if (!this.spot_questions_group_code) {
        this.spot_questions_groups = []
        return
      }

      this.loadAsyncSpotQuestionsGroups()
    }, 1000),
    onSelectSpotQuestionsGroup(option) {
      this.selectedSpotQuestionsGroupName = option && option.name
    },
    onSelectDepartureDate() {
      this.form.departure_date = this.departure_date
    },
    onSelectSignupDeadline() {
      this.form.signup_deadline = this.signup_deadline
    },
    onSelectRegistrationRange() {
      this.form.registration_start_date = this.registration_range[0]
      this.form.registration_end_date = this.registration_range[1]
    },
    send() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      const form = {
        ...this.form,
        departure_date: this.formatDate(this.form.departure_date),
        signup_deadline: this.formatDate(this.form.signup_deadline),
        registration_start_date: this.formatDate(
          this.form.registration_start_date
        ),
        registration_end_date: this.formatDate(this.form.registration_end_date),
        common_questions_group_code: this.common_questions_group_code,
        spot_questions_group_code: this.spot_questions_group_code
      }

      this.$emit('onSend', form)
    },

    filteringCollaborates: debounce(function() {
      this.filteredCollaborates = this.collaborates.filter(option => {
        return (
          option.name
            .toString()
            .toLowerCase()
            .indexOf(this.collaborate_name.toLowerCase()) >= 0
        )
      })
    }, 500),
    filteringActivities: debounce(function() {
      this.filteredActivities = this.activities.filter(option => {
        return (
          option.name
            .toString()
            .toLowerCase()
            .indexOf(this.activity_name.toLowerCase()) >= 0
        )
      })
    }, 500)
  }
}
</script>

<style lang="scss" scoped>
.modal-card {
  min-height: 480px;
}
</style>
